import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customItems = null }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeMap = {
    '/dashboard-home': 'Início',
    '/course-detail-view': 'Detalhes do Curso',
    '/video-player-interface': 'Player de Vídeo',
    '/ai-chat-interface-dai-mentor': 'Mentor Dai',
    '/user-progress-dashboard': 'Meu Progresso',
    '/activity-interface': 'Atividades',
    '/admin-panel-dashboard': 'Painel Admin',
    // Novas rotas de calendário
    '/appointment-request-modal': 'Solicitar Agendamento',
    '/availability-configuration': 'Configurar Disponibilidade',
    '/calendar-main-interface': 'Calendário',
    '/request-management-interface': 'Gerenciar Solicitações',
    '/user-calendar-view': 'Visualizar Calendário'
  };

  const generateBreadcrumbs = () => {
    if (customItems) return customItems;

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Início', path: '/dashboard-home' }];

    if (pathSegments?.length > 0 && location?.pathname !== '/dashboard-home') {
      const currentPath = `/${pathSegments?.join('/')}`;
      const currentLabel = routeMap?.[currentPath] || pathSegments?.[pathSegments?.length - 1];
      
      breadcrumbs?.push({
        label: currentLabel,
        path: currentPath,
        isActive: true
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) return null;

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <nav 
      className="flex items-center space-x-2 text-sm font-caption mb-6 overflow-x-auto scrollbar-hide min-w-0" 
      aria-label="Breadcrumb"
    >
      {breadcrumbs?.map((item, index) => (
        <React.Fragment key={item?.path || index}>
          {index > 0 && (
            <Icon 
              name="ChevronRight" 
              size={16} 
              className="text-muted-foreground flex-shrink-0" 
            />
          )}
          
          {item?.isActive ? (
            <span className="text-foreground font-medium truncate max-w-[200px] sm:max-w-[300px] whitespace-nowrap">
              {item?.label}
            </span>
          ) : (
            <button
              onClick={() => handleNavigation(item?.path)}
              className="text-muted-foreground hover:text-foreground transition-micro truncate max-w-[150px] sm:max-w-[200px] whitespace-nowrap"
            >
              {item?.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;